module.exports = __webpack_public_path__ + "static/media/pop.e2e956ce.mp3";